module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_5.64d16b2a.png";